import { Form, Formik } from 'formik';
import React from 'react';

import {
    changeDeliveryLineOrder,
    updateDeliveryLineFromProject,
} from '~/@user-store/deliveryLines/deliveryLine.requests';
import { ProjectWeightReceiptInfo } from '~/@user-store/weightReceipts/projectWeightReceipts.store';
import { IProject } from '~/@views/UserView/ProjectPage/ProjectMassesDetails/types';

import { DeliveryLineEditActions } from './DeliveryLineEditActions';
import { DeliveryLineEditFields } from './DeliveryLineEditFields';
import { DeliveryLineEditLayout } from './DeliveryLineEditLayout';
import { DeliveryLineReceiptView } from './DeliveryLineReceiptView';
import { getDeliveryLineUpdateFormikConfig } from './DeliveryLineUpdateFormik';

type Props = {
    project: IProject;
    deliveryLine: ProjectWeightReceiptInfo;
    onClose: (v: boolean) => void;
};

export const DeliveryLineUpdateForm = ({ project, deliveryLine, onClose }: Props) => {
    return (
        <Formik
            {...getDeliveryLineUpdateFormikConfig(
                input => updateDeliveryLineFromProject(project.id, input),
                input => changeDeliveryLineOrder(input),
                project,
                deliveryLine
            )}>
            {({ values }) => (
                <DeliveryLineEditLayout
                    form={
                        <Form>
                            <DeliveryLineEditFields />
                            <DeliveryLineEditActions onClose={onClose} />
                        </Form>
                    }
                    preview={<DeliveryLineReceiptView deliveryLine={deliveryLine} newReceipt={values.receipt} />}
                />
            )}
        </Formik>
    );
};
